import React from 'react';

interface OutlinedMoldIconProps extends React.SVGAttributes<SVGElement> {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  showHolders?: boolean;
  showMouth?: boolean;
}

const OutlinedMoldIcon: React.FC<OutlinedMoldIconProps> = ({
  size = 24,
  color = '#000000',
  strokeWidth = 80,
  showHolders = false,
  showMouth = false,
  ...props
}) => {
  // Use strokeWidth directly for all strokes
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Mold holders */}
      {showHolders && (
        <>
          {/* Left holder: connector line + donut circle */}
          <rect
            x="368"
            y="152"
            width="32"
            height="48"
            rx="10"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
          />
          <circle
            cx="384"
            cy="128"
            r="48"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
          />
          <circle
            cx="384"
            cy="128"
            r="18"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
          />
          {/* Right holder: connector line + donut circle */}
          <rect
            x="624"
            y="152"
            width="32"
            height="48"
            rx="10"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
          />
          <circle
            cx="640"
            cy="128"
            r="48"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
          />
          <circle
            cx="640"
            cy="128"
            r="18"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
          />
        </>
      )}

      {/* Mold base */}
      <rect
        x="128"
        y="192"
        width="768"
        height="640"
        rx="64"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
      />

      {/* Feet */}
      <rect x="192" y="832" width="128" height="48" rx="12" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <rect x="704" y="832" width="128" height="48" rx="12" stroke={color} strokeWidth={strokeWidth} fill="none" />

      {/* Eyes */}
      <circle cx="400" cy="420" r="24" fill={color} stroke="none" />
      <circle cx="624" cy="420" r="24" fill={color} stroke="none" />

      {/* Smile */}
      {showMouth && (
        <path
          d="M432 500c48 50 102 50 150 0"
          stroke={color}
          strokeWidth={36} // fixed stroke width for mouth
          strokeLinecap="round"
        />
      )}

      {/* Left-side vertical oval slots */}
      <rect x="140" y="340" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="140" y="400" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="140" y="460" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="140" y="520" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="140" y="580" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />

      {/* Right-side vertical oval slots */}
      <rect x="872" y="340" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="872" y="400" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="872" y="460" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="872" y="520" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
      <rect x="872" y="580" width="12" height="32" rx="6" fill="none" stroke={color} strokeWidth={strokeWidth / 2} />
    </svg>
  );
};

export default OutlinedMoldIcon;
